import { useState, useCallback } from 'react';

export const useDisclose = (initialValue = false) => {
  const [isOpen, setIsOpen] = useState(initialValue);
  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    onOpen,
    onClose,
  };
};
